import { get } from 'lodash-es';
import {
  DEAL_COMPLETED,
  DEAL_IN_PROGRESS,
  DEAL_NOT_STARTED,
  DEAL_STATUS_PENDING,
  DEAL_STATUS_SOLD,
} from 'site-modules/shared/constants/financing/caramel';
import { ClientConfig } from 'client/configuration';
import { CaramelApi } from 'client/data/api/api-client';
import { logger } from 'client/utils/logger/logger';

export const isCaramelEligible = vinData => !!get(vinData, 'prices.advertisedPrice');

export const getDealStatus = buyerStatus => {
  switch (buyerStatus) {
    case DEAL_IN_PROGRESS:
    case DEAL_NOT_STARTED:
      return DEAL_STATUS_PENDING;

    case DEAL_COMPLETED:
      return DEAL_STATUS_SOLD;
    default:
      return null;
  }
};

export async function createPrivatePartyDeal(data) {
  const options = {
    method: 'POST',
    retries: 0,
    headers: {
      'content-type': 'application/json',
    },
    showAPIError: true,
    timeout: ClientConfig.get('carBuying').apiDefaultTimeoutMs,
  };

  try {
    const { protocol, hostName, listingId, visitorId, sessionId } = data;
    const caramelApiUrl = ClientConfig.get('caramelApiUrl');
    const url = /^(https:\/\/)/.test(caramelApiUrl) ? caramelApiUrl : `${protocol}://${hostName}${caramelApiUrl}`;
    const response = await CaramelApi(url).fetchJson('/create-private-party-deal', {
      ...options,
      body: JSON.stringify({ listingId, visitorId, sessionId }),
    });

    return response;
  } catch (e) {
    logger.error(`Caramel create deal API error - ${e}`);
    if (!e.apiUrl) {
      e.apiUrl = `${ClientConfig.get('caramelApiUrl') || ''}/create-private-party-deal`;
    }
    return e;
  }
}
